// Your web app's Firebase configuration
import { initializeApp } from "firebase/app";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyArxHbZ4iasvC1SC6vQs23qwe9NPg1SU2A",
  authDomain: "email-ai-companion.firebaseapp.com",
  projectId: "email-ai-companion",
  storageBucket: "email-ai-companion.appspot.com",
  messagingSenderId: "167201789295",
  appId: "1:167201789295:web:9bba76a7a6ecaa85d9449a",
  measurementId: "G-J4VRZJPSK3"
};

let app;
let db;
let analytics;
let auth;
let functions;

try {
  // Initialize Firebase
  app = initializeApp(firebaseConfig);
  db = getFirestore(app);
  auth = getAuth(app);
  analytics = getAnalytics(app);
  // Initialize functions with region
  functions = getFunctions(app, 'us-central1');

  // Enable offline persistence
  enableIndexedDbPersistence(db).catch((err) => {
    if (err.code === 'failed-precondition') {
      console.log('Multiple tabs open, persistence can only be enabled in one tab at a time.');
    } else if (err.code === 'unimplemented') {
      console.log('The current browser does not support persistence.');
    }
  });
} catch (error) {
  console.error("Error initializing Firebase:", error);
}

export { app, db, analytics, auth, functions };
